import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTextarea,_vm._g(_vm._b({attrs:{"outlined":"","dense":"","single-line":""}},'v-textarea',{
    rows: 6,
    ..._vm.$attrs,
  },false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }